import { Icon } from '@lbcamden/lib-react';
import { FunctionComponent } from 'react';
import { useLocation } from 'react-router';

import { routes } from '~/client/config/routes';

import { UserMenu } from '../UserMenu';
import { AppToolbarRoot, HomeLink } from './AppToolbar.styled';

const nonRenderRoutes: string[] = [routes.login, routes.authRegistration, routes.authFailed];

export const AppToolbar: FunctionComponent = () => {
  const { pathname } = useLocation();

  if (nonRenderRoutes.includes(pathname)) {
    return null;
  }

  return (
    <AppToolbarRoot
      homeLink={
        <HomeLink aria-label="Home" to={routes.home}>
          <Icon icon="logos/home-visits-logo-white" $color="white" width={130} />
        </HomeLink>
      }
      items={[<UserMenu key="user" />]}
    />
  );
};
